module.exports = __webpack_public_path__ + "img/img9.12e7b097.png";